//引入请求文件
import request from './request.js';

export default{
	// 获取同意协议的记录
	getAgreementList(params){
		return request({
			url: '/Company/GetAllAgreementConsentRecord'+params,
			method: 'get'
		})
	},
    // 协议单独页面需要的一个接口
    getAgreement(params){
      return request({
        url:'/Company/GetAgreementConsentRecord'+params,
        method:'get'
      })
    },
    // //请求方式这么写
     Login(params) {
       //手机号  密码
      return request({
        url: '/TBEmployee/Login'+ params,//需要字符串拼接这么写
        method: 'post',
      });
    },
}
		//请求方式这么写
		//  XXX(params) {
		//   return request({
		//     url: '/seller/shopArea/getShopAreaRedis'+params,  //1.需要字符串拼接这么写，不需要就删掉，在data中定义你传的参数
		//     method: 'post',   //请求方式 post、get
		//     data: params   //2.对象传参这么写
		//   });
		// }

		//3.不传参数 删去所有 params

        //接口请求方式
        // let addInfo = this.addInfo //参数
        // this.$http.接口名称(参数). then(res=>{ })   // $http 可更改（根据 main.js 里设置的定）
        // this.$http.addStaffInfo(addInfo).then(res=>{
        //   console.log(res)
        //   if(res.data.code == 200){
        //     //关闭弹框
        //     this.dialogFormVisibleAdd = false
        //     this.$message.success({
        //       message: '修改成功！'
        //     })
        //     //页面刷新
        //     this.reload()
        //   }else{
        //     this.$message.success({
        //       message: '添加员工失败！'
        //     })
        //   }
        // })
